import React, { useEffect, useState } from 'react'
import ExploreHomeLayout1 from 'src/components/Explore/HomeLayout1'
import { useInitiativeList, useOrganization } from 'src/graphql/hooks'

// =======================================================
// Layouts
// =======================================================

const layouts = [
   null,
   ExploreHomeLayout1
]

// =======================================================
// Page
// =======================================================

const ExploreHome = () => {
   const { organization } = useOrganization()
   const { initiativeList } = useInitiativeList({ archived: 'exclude' })

   const defaultLayout = layouts[1]
   const ExploreLayout = layouts[1] || defaultLayout

   const [initiativesGroupedByType, setInitiativesGroupedByType] = useState([])
   useEffect(() => {
      const initiatveListMap = initiativeList.items.reduce((result, initiative) => {
         if (typeof result[initiative.type.id] !== 'object') {
            result[initiative.type.id] = []
         }

         result[initiative.type.id].push(initiative)
         return result
      }, {})

      setInitiativesGroupedByType(
         organization.initiativeTypes
         .filter(type => type.enabled && Array.isArray(initiatveListMap[type.id]))
         .map(type => ({
            ...type,
            initiatives: initiatveListMap[type.id]
         }))
      )
   }, [initiativeList])

   return (
      <ExploreLayout
         initiativesGroupedByType={initiativesGroupedByType}
      />
   )
}

export default ExploreHome
